import axios from 'axios';
import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  state: {
    category_list: {},
    box_list: {},
    default_cate: null,
    default_cate_name:'',
    res_signup: '',
    res_sms:'',
    skelton:false,
    box_details:{},
    custom_pizza:{
      food_id:'',
      dough_id:'',
      size_id:'',
      component:[],
      extra:[],
      price:null,
    },
    count_cart:0,
    all_data_cart:{},
    cartData:null,
    grand_total:null,
    items_total:null,
    setting_app:{},
    levering_status:{},
    getaddressbylatlng:'',
    response_new_address:{},
    dayPre:{},
    cash_res:{},
    vipps_res:{},
    add_cart_res:{},
    stripe_card_list:{},
    sumup_card_list:{},
    stripe_res:{},
    sumup_res:{},
    update_profile_name:{},
    order_profile:{},
    // 
    object_result_pay_done:{},
    // 
     coupon_object:{},
     string_local_list:{},
     before_dicount:null,
     final_item_total:null,
  },
  getters: {
    getCate_list(state) {
      return state.category_list;
    },
    getBox_list(state) {
      return state.box_list;
    },
    get_default_cate(state) {
      return state.default_cate
    },
    get_box_details(state){
      return state.box_details;
    },
    get_count_cart(state){
      return state.count_cart
    },
    get_data_cart(state){
      return state.cartData;
    },
    all_data_cart(state){
      return state.all_data_cart
    },
    get_grand_total(state){
      return state.grand_total;
    },
    get_sub_total(state){
      return state.items_total;
    },
    get_setting_app(state){
      return state.setting_app;
    },
    get_levering_status(state){
      return state.levering_status;
    },
    get_addressby_latlng(state){
      return state.getaddressbylatlng;
    },
    get_response_addAddress(state){
      return state.response_new_address
    },
    getDayPre(state){
      return state.dayPre
    },
    get_vipps_res(state){
      return state.vipps_res;
    },
    get_add_cart_res(state){
      return state.add_cart_res;
    },
    get_stripe_card_list(state){
      return state.stripe_card_list;
    },
    get_stripe_res(state){
      return state.stripe_res;
    },
    get_sumup_card_list(state){
      return state.sumup_card_list;
    },
    get_sumup_res(state){
      return state.sumup_res;
    },
    get_update_profile_name(state){
      return state.update_profile_name;
    },
    get_order_profile(state){
      return state.order_profile;
    },
    get_cash_res(state){
      return state.cash_res;
    },
    get_object_result_pay_done(state){
      return state.object_result_pay_done;
    },
    get_default_name_category(state){
      return state.default_cate_name;
    },
     // 
     get_before_dicount(state){
      return state.before_dicount;
    },
    get_coupon_object(state){
      return state.coupon_object;
    },
    get_local_string(state){
      return state.string_local_list;
    },
    get_final_item_total(state){
      return state.final_item_total;
    },
  },
  mutations: {

    // Meny Page Mutaions
    SET_CATE(state, category_list) {
      state.category_list = category_list;
    },
    SET_BOX_CATE(state, box_list) {
      state.box_list = box_list;
    },
    SET_DEFALUT(state, default_cate) {
      state.default_cate = default_cate;
    },
    SET_DEFALUT_NAME(state,name){
      state.default_cate_name = name;
    },
    SET_BOX_DETAILS(state, box_details) {
      state.box_details = box_details;
    },
    SET_CART_COUNT(state, count_cart){
        state.count_cart = count_cart;
    },
    SET_GRAND_TOTAL(state,grand_total){
      state.grand_total = grand_total;
    },
    SET_SUB_TOTAL(state,items_total){
      state.items_total = items_total;
    },
    SET_CART_DATA(state , cartData){
      state.cartData = cartData.items;
    },
    SET_ALL_DATA_CART(state, cartData){
      state.all_data_cart = cartData;
    },
    SET_SETTING_APP(state , setting_app){
      state.setting_app = setting_app
    },
    SET_LEVERING_STATUS(state, levering_status){
      state.levering_status = levering_status;
    },
    SET_ADDRESSBY_LATLNG(state,getaddressbylatlng ){
      state.getaddressbylatlng = getaddressbylatlng
    },
    SET_RES_ADD_ADDRESS(state, response_new_address){
      state.response_new_address = response_new_address
    },
    SET_DAYS(state,selectdays_obj){
    state.dayPre = selectdays_obj
    },
    SET_CASH_RES(state,cash_res){
      state.cash_res = cash_res;
    },
    SET_VIPPS_RES(state,vipps_res){
      state.vipps_res = vipps_res
    },
    SET_ADD_CART_RES(state,add_cart_res){
      state.add_cart_res = add_cart_res;
    },
    SET_STRIPE_CARD_LIST(state,stripe_card_list)
    {
      state.stripe_card_list = stripe_card_list;
    },
    SET_STRIPE_RES(state,stripe_res){
      state.stripe_res = stripe_res;
    },
    SET_SUMUP_CARD_LIST(state,sumup_card_list)
    {
      state.sumup_card_list = sumup_card_list;
    },
    SET_SUMUP_RES(state,sumup_res){
      state.sumup_res = sumup_res;
    },
   SET_UPDATE_PROFILE_NAME(state , update_profile_name){
     state.update_profile_name = update_profile_name;
   },
   SET_ORDER_PROFILE(state,order_profile){
     state.order_profile = order_profile;
   },
   SET_OBJECT_RESULT_PAY_DONE(state , object_result_pay_done){
     state.object_result_pay_done = object_result_pay_done;
   },
  //  
  SET_BEFORE_DISCOUNT(state,before_dicount){
    state.before_dicount = before_dicount;
  },
  SET_COUPON_OBJECT(state , coupon_object){
     state.coupon_object =  coupon_object;
  },
  SET_LOCAL_STRING(state , string_local_list){
    state.string_local_list = string_local_list;
  },
  SET_final_item_total(state,final_item_total){
    state.final_item_total = final_item_total;
  },
 
    // end Many Page Mutaions 

  },
  actions: {

    // setting api 
    async get_setting_api({commit}){
      await axios({ method: 'GET', url: '/setting/show?lang='+localStorage.getItem('Fav_lang'), validateStatus: () => true }).then(response=>{
        commit('SET_SETTING_APP' , response.data.app_info);
      });
    },
  
    async getAddressFrom({commit},markerpos) {
      var latLngObj = {
        lat: markerpos.lat,
        lng: markerpos.lng
    }
      Vue.$geocoder.setDefaultMode('lat-lng');
       Vue.$geocoder.send(latLngObj, response => {
      commit('SET_ADDRESSBY_LATLNG',  response.results[0].formatted_address);
      });
    },
    // Meny Page Action 
    async getCategoryMenu_Api({ commit }) {
      await axios({ method: 'POST', url: '/categories' , data:{
        'lang':localStorage.getItem('Fav_lang')
      }, validateStatus: () => true }).then(response=>{
        commit('SET_CATE', response.data.data.categories);
    });
    },
    async getboxCategory_Api({ commit, state }) {
      await axios({ method: 'POST', url: '/categories', data:{
        'lang':localStorage.getItem('Fav_lang')
      }, validateStatus: () => true }).then(response=>{
        if (state.default_cate == null) {
              commit('SET_DEFALUT', response.data.data.categories[0].id);
              commit('SET_DEFALUT_NAME' , response.data.data.categories[0].name);
            }
      });

       axios({ method: 'POST', url: '/categories/'+ state.default_cate, data:{
        'lang':localStorage.getItem('Fav_lang')
      }, validateStatus: () => true }).then(response=>{
        // save box of this category ex kebabe 7 box etc...
        commit('SET_BOX_CATE', response.data.data.data); 
      });
    },

    // on change category
    change_category({ commit, state},kate) {
      commit('SET_DEFALUT', kate.id);
      commit('SET_DEFALUT_NAME' ,kate.name);
      state.skelton=true;
       axios({ method: 'POST', url: '/categories/'+state.default_cate , data:{
        'lang':localStorage.getItem('Fav_lang')
      }, validateStatus: () => true }).then(response=>{
        commit('SET_BOX_CATE', response.data.data.data);
        state.skelton=false;
      });
    },

    change_category_by_name({ commit, state},name) {
      state.skelton=true;
      axios({ method: 'POST', url: '/categories/'+name , data:{
        'lang':localStorage.getItem('Fav_lang')
      }, validateStatus: () => true }).then(response=>{
        commit('SET_DEFALUT', response.data.data.id);
           commit('SET_DEFALUT_NAME' ,response.data.data.name);
        //   // save box of this category ex kebabe 7 box etc...
           commit('SET_BOX_CATE', response.data.data.data);
           state.skelton=false;
      });
    },


    // get box info in page details til
    async box_details({commit, state},boxid){
      state.skelton=true;
      await axios({ method: 'POST', url: '/categories/'+state.default_cate+"/"+boxid , data:{
        'lang':localStorage.getItem('Fav_lang')
      }, validateStatus: () => true }).then(res=>{
        commit('SET_BOX_DETAILS' , res.data.data);
        if(res.data.data.dough.length>0){
          state.custom_pizza.dough_id = res.data.data.dough[0].id;
          state.custom_pizza.price = res.data.data.dough[0].data[0].price;
          state.custom_pizza.size_id = res.data.data.dough[0].data[0].size_id;
        }
        else{
          state.custom_pizza.price = res.data.data.price; 
        }
        state.custom_pizza.food_id = res.data.data.id;
        if(state.custom_pizza.component.length > 0)
        {
          state.custom_pizza.component=[];
        }
        // fill default component
        res.data.data.components.forEach(element => {
          element.data.forEach((comp)=>{
            if(comp.basic>0)
            {
              state.custom_pizza.component.push(comp.id);
            }
          })
        });
        
        state.skelton=false;
      });
    }
    // End Meny Page Action 
    ,
    async add_to_cart(_,itemAdded){
      await axios({ method: 'POST', url: '/cart/add' , data:{
        'food_id':itemAdded.food_id , 
         'default':itemAdded.default,
         'dough_id':itemAdded.dough_id,
         'size_id': itemAdded.size_id,
         'qty': itemAdded.qty,
         'component': itemAdded.component,
         'extra': itemAdded.extra,
         'platform': itemAdded.platform,
         'lang':localStorage.getItem('Fav_lang')
      }, validateStatus: () => true }).then(res=>{
          this.dispatch('get_data_cartAction' , res)
      });
    },
    async get_data_cartAction({commit}){
    
      await axios({ method: 'POST', url: '/cart/dataAll' ,data:{
        'lang':localStorage.getItem('Fav_lang')
      }, validateStatus: () => true }).then(res=>{
        console.log('cart finished')
        commit('SET_ALL_DATA_CART' , res.data);
        // 
        commit('SET_BEFORE_DISCOUNT' , res.data.data.before_dicount); 
        commit('SET_COUPON_OBJECT' ,  res.data.data.coupon);
        commit('SET_final_item_total' , res.data.data.final_items_total);
        // 
        commit('SET_GRAND_TOTAL' , res.data.data.grand_total); 
        commit('SET_SUB_TOTAL' , res.data.data.items_total);
        commit('SET_CART_COUNT' , res.data.data.count_qty);
        commit('SET_CART_DATA', res.data.data);
      });
    },
    async update_data_cart(_,item_updete){
      await axios({ method: 'POST', url: '/cart/update',data:{

          'item_id': item_updete.item_id,
          'quantity': item_updete.item_qty,
          'platform':'web',
          'lang':localStorage.getItem('Fav_lang')
      },validateStatus: () => true }).then(res=>{
        console.log(res);
      });
      await this.dispatch('get_data_cartAction')
    },
    async delete_data_cart(_ , item_updete  ){
      await axios({ method: 'POST', url: '/cart/remove',data:{
        'item_id': item_updete.item_id,
        'platform':'web',
        'lang':localStorage.getItem('Fav_lang')
      } , validateStatus: () => true }).then(res=>{
        console.log(res);

      });
      await this.dispatch('get_data_cartAction')
    },
    async delevery_levering({commit},levering_method){
      await axios({ method: 'POST', url: '/cart/delivery',data:{
        'delivery_method': levering_method.delivery_method,
        'delivery_address':levering_method.delivery_address,
        'lang':localStorage.getItem('Fav_lang')
      } , validateStatus: () => true }).then(res=>{
           this.dispatch('get_data_cartAction');
           commit('SET_LEVERING_STATUS', res.data);
    
      });
    },
    async add_new_address({commit},new_address){
      let latlong  = `${new_address.lat},${new_address.lng}`
      let format_newaddress = {
        lat_long: latlong,
        address_text:new_address.address_text
      }
      await axios({ method: 'POST', url: '/addAddress',data:format_newaddress , validateStatus: () => true }).then(res=>{
        commit('SET_RES_ADD_ADDRESS' , res.data);
        this.dispatch('auth/attempt');
      });
    },
    async remove_address(_,address_id)
    {
      await axios({ method: 'POST', url: '/deleteAddress',data:{
        id:address_id
      } , validateStatus: () => true });
      await this.dispatch('auth/attempt');
    },
    async select_day({commit},date_today){
      await axios({ method: 'POST', url: '/cart/selectDay',data:{
        date:date_today
      } , validateStatus: () => true }).then((res)=>{
        commit('SET_DAYS' , res.data.data)
      });
    },
    async create_order(_,order_details)
    {
      await axios({ method: 'POST', url: '/order/add',
      data:{
        "platform" : order_details.platform ,
        "note": order_details.note,
        "admin_order_date": order_details.admin_order_date,
        'lang':localStorage.getItem('Fav_lang')
      }, validateStatus: () => true });
    },
    async order_details_vipps({commit},order_obj_route){
      console.log(order_obj_route , 'order_obj_route1');
       let response_order_vipps = {}
    await axios({ method: 'POST', url: '/order/data' , data:{
      'platform':'web',
      'order_code':order_obj_route,
    }, validateStatus: () => true }).then((res)=>{
       commit('SET_OBJECT_RESULT_PAY_DONE' , res.data.data);
      console.log('get order details success' , res);
      response_order_vipps = res.data;
    });
    return response_order_vipps;
    },
    async pay_cash_method({commit})
    {
      await axios({ method: 'POST', url: '/payment/cash',data:{
        'platform':'web',
        'lang':localStorage.getItem('Fav_lang')
      }, validateStatus: () => true }).then((res)=>{
        this.dispatch('get_data_cartAction');
        commit('SET_CASH_RES' , res.data.data);
        commit('SET_OBJECT_RESULT_PAY_DONE' , res.data.data);
      });
    },
    async pay_vipps_method({commit})
    {
      await axios({ method: 'POST', url: '/payment/vipps', data:{
        'platform':'web',
        'lang':localStorage.getItem('Fav_lang')
      }, validateStatus: () => true }).then((res)=>{
        commit('SET_VIPPS_RES' , res.data.data);
        commit('SET_OBJECT_RESULT_PAY_DONE' , res.data.data);
        console.log(res.data.data,'vipps response');
        this.dispatch('get_data_cartAction');
      });
    },
    async add_new_card({commit},card_info){
      await axios({ method: 'POST', url: '/payment/strip_add_card/',data:{
        'number': card_info.number,
        'exp_date':card_info.exp_date,
        'cvc':card_info.cvc,
        'name': card_info.name,
        'platform':'web',
        'lang':localStorage.getItem('Fav_lang')
      } , validateStatus: () => true }).then((res)=>{
       commit('SET_ADD_CART_RES', res.status);
       this.dispatch('stripe_card_list');
      });
    },
    async remove_card_stripe(_,card_id){
      await axios({ method: 'POST', url: '/payment/strip_remove_card/',data:{
        'card_id': card_id,
        'platform':'web',
        'lang':localStorage.getItem('Fav_lang')
      } , validateStatus: () => true }).then(()=>{
       this.dispatch('stripe_card_list');
      });
    },
    async stripe_card_list({commit}){
      await axios({ method: 'POST', url: '/payment/strip_cards/' , validateStatus: () => true }).then((res)=>{
       commit('SET_STRIPE_CARD_LIST', res.data);
      });
    },
    async pay_stripe_method({commit},card_id)
    {
      await axios({ method: 'POST', url: '/payment/strip/', data:{
        'strip_viza':card_id,
        'platform':'web',
        'lang':localStorage.getItem('Fav_lang')

      } ,validateStatus: () => true }).then((res)=>{
        commit('SET_STRIPE_RES' , res.data);
        commit('SET_OBJECT_RESULT_PAY_DONE' , res.data.data);
        this.dispatch('get_data_cartAction');
      });
    },
    // sumup func
    async sumup_card_list({commit}){
      await axios({ method: 'POST', url: '/payment/sumup_cards/' , validateStatus: () => true }).then((res)=>{
       commit('SET_SUMUP_CARD_LIST', res.data);
      });
    },
    async pay_sumup_method({commit},card_id)
    {
      await axios({ method: 'POST', url: '/payment/sumup/', data:{
        'card_id':card_id,
        'platform':'web',
        'lang':localStorage.getItem('Fav_lang')

      } ,validateStatus: () => true }).then((res)=>{
        commit('SET_SUMUP_RES' , res.data);
        commit('SET_OBJECT_RESULT_PAY_DONE' , res.data.data);
        this.dispatch('get_data_cartAction');
      });
    },
    async remove_card_sumup(_,card_id){
      await axios({ method: 'POST', url: '/payment/sumup_remove_card/',data:{
        'card_id': card_id,
        'platform':'web'
      } , validateStatus: () => true }).then(()=>{
       this.dispatch('sumup_card_list');
      });
    },
    async add_new_card_sumup({commit},card_info){
      await axios({ method: 'POST', url: '/payment/sumup_add_card/',data:{
        'number': card_info.number,
        'exp_date':card_info.exp_date,
        'cvc':card_info.cvc,
        'name': card_info.name,
        'platform':'web'
      } , validateStatus: () => true }).then((res)=>{
       commit('SET_ADD_CART_RES', res.data);
       this.dispatch('sumup_card_list');
      });
    },
    // signup function Api
    async signUp_user({state} , payload) {
      await axios({ method: 'POST', url: '/signup', data: payload, validateStatus: () => true }).then(res => {
        return (state.res_signup = res.status);
      });
    },
    // get Mobile Number 
     async getMobileNumber(_,mobile){
      await axios({method:"POST" , url:'/activeMobile' , data:{'mobile':mobile}}).then(()=>{
      }).catch(()=>{
        console.log('error');
      })
     }
     ,
    //  Active Sms
    async activeSms({state},smscode){
      await axios({method:"POST" , url:'/activeCode' , data:{'code':smscode}, validateStatus:()=>true}).then((response)=>{
        return (state.res_sms = response);
      }).catch(()=>{
         console.log('error');
      })
    },
    async updateprofile({commit},newName){
      await axios({method:"POST" , url:'/updateProfile' , data:{'name':newName}}).then((res)=>{
      commit('SET_UPDATE_PROFILE_NAME' , res.status);
      this.dispatch('auth/attempt');
      }).catch(()=>{
         console.log('error');
      })
     },
     async order_histroy_api({commit}){
      await axios({method:"POST" , url:'/orderHistory'}).then((res)=>{
      commit('SET_ORDER_PROFILE' , res.data);
      }).catch(()=>{
        console.log('error');
      })
     },
     async change_password_api(_,password_obj){
      let response_pass={};
      await axios({ method: 'POST', url: '/changePassword' ,data:password_obj, validateStatus: () => true }).then(res=>{
       response_pass =  res.data;
      });
      return response_pass;
     },
    //  tulbid multi product added
    async multi_product_add(_,multi_products){
    //  console.log(multi_products,'st');
    // console.log(multi_products , 'multi objects store');
      let response_multi={};
      await axios({ method: 'POST', url: '/cart/add' ,data:{
        'food_id': multi_products.food_id,
        'default': multi_products.default,
        'qty':     multi_products.qty,
        'product_multi':multi_products.product_multi,
        'platform':multi_products.platform,
        'lang':localStorage.getItem('Fav_lang'),
        'entrees':multi_products.entrees,
      }, validateStatus: () => true }).then(res=>{
        response_multi =  res.data;
        this.dispatch('get_data_cartAction');
      });
      return response_multi;
    },
    //half half product tilbud
    async half_product_add(_,halfhalf_products){
      // console.log(halfhalf_products,'st');
       let response_half={};
       await axios({ method: 'POST', url: '/cart/add' ,data:{
        'default': halfhalf_products.default,
        'food_1': halfhalf_products.food_1,
        'food_2': halfhalf_products.food_2,
        'food_id': halfhalf_products.food_id,
        'platfor': "web",
        'qty':halfhalf_products.qty ,
        'lang':localStorage.getItem('Fav_lang')
      }, validateStatus: () => true }).then(res=>{
         response_half =  res.data;
         this.dispatch('get_data_cartAction');
       });
       return response_half;
     },
     async apply_coupon_code_api(_,coupon_code){
      let response_apply_code={};
      await axios({ method: 'POST', url: '/cart/applyCoupon' ,data:{
       'code':coupon_code,
       'platform':'web'
      }, validateStatus: () => true }).then(res=>{
       response_apply_code =  res.data;
        this.dispatch('get_data_cartAction');
      });
      return response_apply_code;
    },
    async remove_coupon_code_api(){
      let response_remove_code={};
      await axios({ method: 'POST', url: '/cart/removeCoupon', validateStatus: () => true }).then(res=>{
       response_remove_code =  res.data;
        this.dispatch('get_data_cartAction');
      });
      return response_remove_code;
    },
    async list_coupon_code_api(){
      console.log('call list')
      let response_list_code={};
      await axios({ method: 'get', url: '/cart/couponList', validateStatus: () => true }).then(res=>{
       response_list_code =  res.data;
        this.dispatch('get_data_cartAction');
      });
      return response_list_code.data;
    },
     // String api 
     async get_string_api({commit}){
       await axios({ method: 'get', url: '/string', validateStatus: () => true }).then(res=>{
        if(localStorage.getItem('Fav_lang')==null){
          localStorage.setItem('Fav_lang', 'NO');
          commit('SET_LOCAL_STRING' ,res.data.data.NO.stringList);
         }else if(localStorage.getItem('Fav_lang')=='NO'){
           localStorage.setItem('Fav_lang', 'NO');
          commit('SET_LOCAL_STRING' ,res.data.data.NO.stringList);
         }else{
          localStorage.setItem('Fav_lang', 'EN');
          commit('SET_LOCAL_STRING' ,res.data.data.EN.stringList); 
         } 
       });
     },
     async check_email_api(_,email){
      let response_checkemail={};
      await axios({ method: 'POST', url: '/restorePassword' ,data:{
        'username':email
      }, validateStatus: () => true }).then(res=>{
        response_checkemail =  res.data;
      });
      return response_checkemail;
     },
     async restore_pass_api(_,restoredata){
      let response_restorepass={};
      await axios({ method: 'POST', url: '/resetPassword' ,data:{
        'user_id':restoredata.uid,
        'code': restoredata.codeemail,
        'password':restoredata.password
      }, validateStatus: () => true }).then(res=>{
        response_restorepass =  res.data;
      });
      return response_restorepass;
     },
     async delete_account_api(){
      let response_delete={};
      await axios({ method: 'POST', url: '/deactivateAccount' , validateStatus: () => true }).then(res=>{
        console.log(res.data);
        response_delete =  res.data;
      });
      return response_delete;
     }

     
  }
  , modules: {
    // login auth
    auth
  }
})

